import { ReferenceFormAccess } from "../interfaces/referenceFormAccesss";

const PROD_APP_URL = process.env.REACT_APP_PROD_APP_URL || "";
const API_URL = process.env.REACT_APP_API_URL || "";
const DEV_API_URL = process.env.REACT_APP_DEV_API_URL || "";
const PROD_API_URL = process.env.REACT_APP_PROD_API_URL || "";

const apiBaseUrl =
  window.location.hostname === "localhost"
    ? API_URL
    : window.location.hostname === new URL(PROD_APP_URL).hostname
    ? PROD_API_URL
    : DEV_API_URL;

export const getReferenceAccessByToken = async (
  referenceToken: string
): Promise<ReferenceFormAccess> => {
  if (!apiBaseUrl) {
    throw new Error("API URL is not defined");
  }

  const referenceFormAccessResponse = await fetch(
    `${apiBaseUrl}/api/ReferenceFormAccess/GetReferenceFormAccessByToken/${referenceToken}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  if (!referenceFormAccessResponse.ok) {
    throw new Error("Failed to fetch reference form access");
  }

  const referenceFormAccess = await referenceFormAccessResponse.json();

  return referenceFormAccess;
};
